export const hoaDon = {
  sections: { list: { title: '发票' }, detail: { title: '发票详情' } },
  lineList: {
    title: '发票商品明细',
    tabInvoices: '发票',
    tabLines: '商品明细',
    summary: '共 {count} 行商品',
    noData: '暂无数据',
    columns: {
      maHoaDon: '发票号',
      thoiGian: '时间',
      trangThai: '状态',
      chiNhanh: '分店',
      nguoiBan: '销售员',
      maKhachHang: '客户编码',
      tenKhachHang: '客户名称',
      maHangHoa: '商品编码',
      tenHangHoa: '商品名称',
      donViTinh: '单位',
      soLuong: '数量',
      tongCanNang: '重量 (kg)',
      tongTheTich: '体积 (m³)',
      donGia: '单价',
      giamGia: '行折扣',
      giaBan: '售价',
      thanhTien: '金额',
      giamGiaChung: '整单折扣',
      thuKhacChung: '其他收费',
      tongCong: '合计',
      ghiChu: '备注',
    },
  },
  titles: { add: '新增发票' },
  tabs: {
    banNhanh: '快速销售',
    banThuong: '标准销售',
    banGiaoHang: '配送销售',
  },
  columns: { code: '单号', summary: '信息', status: '状态', ngayTao: '创建时间', ngayCapNhat: '更新时间' },
  filter: { searchPlaceholder: '按发票号搜索...' },
  filters: {
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    all: '全部',
    fromDate: '开始日期',
    toDate: '结束日期',
    dateRange: '时间范围',
    dateRangePlaceholder: '选择日期范围',
    status: '状态',
    statusSection: '发票状态',
    dateSection: '时间',
    thoiGianBan: '销售时间',
    thoiGianTao: '创建时间',
    salesSection: '销售',
    peopleSection: '用户',
    seller: '销售员',
    deliverySection: '配送',
    deliveryPartner: '配送伙伴',
    deliveryArea: '配送区域',
    deliveryStatus: '配送状态',
    otherIncomeType: '其他收入类型',
    maHang: '货品编号',
    tenHang: '货品名称',
    textDetailTitle: '发票筛选',
    khachHangPlaceholder: '搜索客户',
    loaiBanOnline: '线上销售类型',
    loaiBanOnlineOnline: '线上单',
    loaiBanOnlineBanGop: '合并销售',
    sortField: '排序字段',
    sortDir: '排序方向',
    sortThoiGian: '销售时间',
    sortThoiGianTao: '创建时间',
    sortMaHoaDon: '发票号',
    sortKhachCanTra: '应付金额',
    sortTongTienHang: '商品总额',
  },
  form: {
    code: '发票号',
    codeAuto: '留空自动生成',
    time: '日期时间',
    invoiceType: '发票类型',
    saleType: '销售形式',
    typeNoDelivery: '不配送',
    typeDelivery: '配送',
    customer: '客户',
    customerSearch: '搜索客户 (F4)',
    customerQuickAdd: '快速添加客户',
    customerQuickEdit: '编辑客户',
    congNoHienTai: '当前欠款',
    congNoKhachNo: '客户欠款',
    congNoNoKhach: '欠客户',
    retailCustomer: '散客',
    bangGia: '价格表',
    bangGiaDefault: '默认价格',
    pickupAddress: '取货地址',
    pickupAddressPlaceholder: '选择取货地址',
    pickupAddressEmpty: '暂无取货地址',
    pickupAddressQuickAdd: '快速添加取货地址',
    channel: '销售渠道',
    seller: '销售员',
    saleTime: '销售时间',
    creator: '创建人',
    createdAt: '创建时间',
    discount: '折扣',
    vat: '增值税 (VAT)',
    note: '备注',
    lines: '明细行',
    danhSachChiTiet: '明细列表',
    addLine: '添加行',
    addPriceLine: '添加价格行',
    product: '商品',
    productName: '商品名称',
    productSearch: '搜索编码/名称',
    quickSearch: '搜索商品 (F3)',
    qty: '销售数量',
    unitPrice: '单价',
    salePrice: '售价',
    lineTotal: '小计',
    editPrice: '修改售价',
    priceBelowCost: '警告：单价低于成本价',
    currency: 'VND',
    byAmount: '按金额',
    byPercent: '按 %',
    unit: '换算单位',
    unitFactor: '系数',
    convertedQty: '换算数量',
    lastPrice: {
      label: '最近售价',
      never: '该客户从未购买此商品',
      invoice: '发票',
      qty: '数量',
      unitPrice: '单价',
      discount: '折扣',
      applyHint: '点击将此价格应用到该行',
      unitMismatch: '与当前销售单位不同 — 切换单位后可应用',
    },
    posTable: {
      stt: '# (序号)',
      action: '+ (添加价格行 / 删除)',
      groupEdge: '序号 / 操作列',
      sellUnit: '销售单位',
      sellQty: '销售数量',
      sellUnitPrice: '销售单价',
      sellDiscount: '销售折扣',
      sellPrice: '售价',
      sellTotal: '销售金额',
      baseUnit: '基本单位',
      conversionRate: '换算比例',
      conversionRateHint: '1 销售单位 = 比例 × 基本单位',
      baseQty: '基本数量',
      basePrice: '基本单价',
      baseTotal: '基本金额',
      groupSell: '销售信息',
      groupBase: '基本单位换算',
      columnSettings: '列设置',
      resetColumns: '恢复默认',
      lockedColumn: '必选列',
    },
    discountPercent: '折扣 (%)',
    lineNote: '行备注',
    stock: '库存',
    comboParts: '组合成分',
    comboBadge: '组合',
    stockSystemTitle: '全系统库存',
    lineAmount: '金额',
    delivery: '配送信息',
    savedAddress: '已保存配送信息',
    savedAddressPlaceholder: '选择配送信息',
    savedAddressEmpty: '尚未保存配送信息',
    savedAddressQuickAdd: '快速添加配送信息',
    recipient: '收货人',
    phone: '收货人电话',
    address: '配送地址',
    area: '省/市',
    ward: '坊/社',
    areaEmpty: '— 选择省/市 —',
    wardEmpty: '— 选择坊/社 —',
    deliveryPartner: '配送合作方',
    serviceType: '服务类型',
    trackingCode: '运单号',
    shippingPanelTitle: '物流',
    deliveryPartnerShort: '承运商',
    serviceTypeShort: '服务',
    trackingCodeShort: '运单号',
    appliedFeeShort: '运费',
    deliveryStatusShort: '状态',
    feeNeedAddressHint: '请选省市/坊社',
    packageCount: '件数',
    weight: '重量',
    dimensions: '尺寸',
    dimLength: '长',
    dimWidth: '宽',
    dimHeight: '高',
    dimUnit: '尺寸单位',
    measureUnit: '单位',
    shippingFee: '运费',
    appliedFee: '适用费用',
    cod: '货到付款 (COD)',
    deliveryNote: '给快递员的备注',
    deliveryTime: '交货期限',
    latestDeliveryTime: '交货期限',
    deliveryTimeDefault: '默认',
    deliveryStatus: '配送状态',
    payment: '付款',
    addPayment: '添加付款',
    paymentMethod: '方式',
    amount: '金额',
    paymentNote: '备注',
    otherFee: '其他费用',
    addOtherFee: '添加其他费用',
    thuKhacSeeMore: '查看更多（{count}）',
    thuKhacCollapse: '收起',
    category: '类别',
    value: '数值',
    percent: '百分比',
    noCategory: '暂无其他费用类别',
    customerInfo: '客户信息',
    package: '包裹',
    shippingFeeSection: '运费',
    codToggle: '货到付款 (COD)',
    codAmount: '代收金额',
    shippingViaPartner: 'KiotViet 网关',
    shippingSelf: '配送',
    shippingPartners: 'KiotViet 物流合作方',
    shippingGatewayHint: '请填写完整地址，以便系统估算运费并推荐合适的承运商。',
    discountType: '折扣类型',
    discountValue: '折扣值',
    orderNote: '订单备注',
    tabLines: '商品明细',
    discountShort: '折扣',
    maHang: '商品编号',
  },
  popup: {
    thuKhac: {
      title: '其他费用',
      maThuKhac: '代码',
      loaiThu: '收费类型 / 其他费用',
      ghiChu: '备注',
      ghiChuPlaceholder: '这笔费用是什么…',
      mucThu: '费率',
      thu: '收取',
      applyMucThuHint: '点击将目录费率填入“收取”',
      hint: '费率来自目录。在“收取”输入金额（> 0）才会记入。点击费率可快速填入。',
      total: '合计',
    },
  },
  fields: {
    maKhachHang: '客户编码',
    nhanVienPhuTrach: '客户负责销售',
    soSanPham: '商品种数',
    soLuongSanPham: '商品总数量',
    tongCanNang: '总重量 (kg)',
    tongTheTich: '总体积 (m³)',
    maHoaDon: '发票号',
    maPhieuTraHang: '退货单号',
    maPhieuXuatKho: '出库单',
    maPhieuNhapKho: '入库单',
    maDatHang: '订货单编号',
    maYeuCauSuaChua: '维修申请编号',
    maYeuCauXuatHoaDon: '开票申请编号',
    nguoiTao: '制单人',
    nguoiTaoHeThong: '系统',
    tenKhachHang: '客户名称',
    khachHang: '客户',
    kenhBan: '销售渠道',
    ngayDatHang: '下单时间',
    thoiGianBan: '销售时间',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    thoiGian: '日期时间',
    bangGia: '价格表',
    trangThai: '状态',
    chiNhanh: '门店',
    hinhThucGiao: '配送方式',
    diaChiLayHang: '取货地址',
    nguoiNhan: '收件人',
    dienThoai: '电话',
    diaChi: '地址',
    khuVuc: '区域',
    phuongXa: '坊/社',
    soKien: '件数',
    trongLuong: '重量',
    donViTrongLuong: '重量单位',
    chieuDai: '长',
    chieuRong: '宽',
    chieuCao: '高',
    donViKichThuoc: '尺寸单位',
    dichVu: '配送服务',
    nguoiGiaoDoiTac: '配送员/伙伴',
    thuHoTien: '货到付款',
    soTienCod: 'COD金额',
    phiTraDTGH: '伙伴运费',
    thoiGianGiaoHang: '交货期限',
    ghiChuGiaoHang: '配送备注',
    ghiChuChoBuuta: '快递员备注',
    tongTienHang: '商品总额',
    giamGia: '折扣',
    thuKhac: '其他收入',
    khachCanTra: '应付金额',
    khachThanhToan: '客户付款',
    tienThua: '找零',
    khachDaTra: '已付金额',
    tongSauGiamGia: '折扣后总额',
    nguoiBan: '销售员',
    loaiHoaDon: '发票类型',
    hinhThucBan: '销售形式',
    trangThaiGiaoHang: '配送状态',
    yeuThich: '收藏',
    ghiChu: '订单备注',
    maVanDon: '运单号',
    totalAmount: '总金额',
    paidAmount: '已付金额',
    payAmount: '付款金额',
    paymentMethod: '支付方式',
    actions: '操作',
    chiNhanhXuLy: '处理分店',
    chiNhanhTao: '创建分店',
    nguoiNhanDat: '销售员',
    kichThuoc: '尺寸',
    thuHoTienShort: '代收货款',
    giamGiaHoaDon: '发票折扣',
    phiShip: '运费',
  },
  paymentMethod: {
    TIEN_MAT: '现金',
    THE: '卡',
    VI: '钱包',
    CHUYEN_KHOAN: '转账',
  },
  status: {
    DANG_XU_LY: '处理中',
    HOAN_THANH: '已完成',
    KHONG_GIAO_DUOC: '无法配送',
    DA_HUY: '已取消',
    DA_HUY_DO_CHINH_SUA: '已取消（因编辑）',
  },
  deliveryStatus: {
    CHO_XU_LY: '待处理',
    CHO_LAY_HANG: '待取货',
    DANG_GIAO: '配送中',
    DA_GIAO: '已送达',
    GIAO_THAT_BAI: '配送失败',
    PHAT_KHONG_THANH_CONG: '投递失败',
    DANG_TRA_HANG: '退回中',
    TRA_HANG: '已退回',
    HUY: '已取消',
  },
  messages: {
    loadError: '加载失败。',
    deleteSuccess: '已删除。',
    createSuccess: '已创建发票。',
    updateSuccess: '已更新发票。',
    capNhatConfirm: {
      title: '更新发票',
      intro: '更改发票信息时，系统将：',
      item1: '取消旧发票并创建新发票',
      item1VanHanh: '如更改商品/数量：取消旧发票、创建新发票，仓库重新处理。如仅修改信息：保留发票编号',
      khoDangXuLy: '该订单正在由仓库处理',
      khoChanSuaHang:
        '仓库已开始拣货——不能添加/删除商品或更改数量。仍可修改价格、折扣、客户、配送与备注。',
      khoSuaThongTin: '• 仅修改信息（价格、折扣、客户、配送、备注…）：发票保留编号，仓库收到通知并继续处理。',
      khoDoiHang: '• 更改商品或数量将被阻止——请仓库先取消操作（重置到拣货前），之后修改将创建新发票供仓库重新处理。',
      item1KhongSinhDuoi:
        '仅修改不影响库存的信息（价格、折扣、客户、配送…）：保留发票编号，不生成后缀版本',
      item2: '旧发票的所有付款单将分配给新发票',
      item3: '如果您更改商品数量，请确保门店库存充足，系统将不再检查。',
      question: '您要继续吗？',
      dongY: '同意',
      boQua: '跳过',
    },
    needLines: '请至少添加一行商品。',
    needKhachHang: '请选择客户。',
    validateThoiGianGiaoBeforeThoiGian: '交货时间不能早于单据/订单时间。',
    deliveryTimeBeforeNow: '新的交货期限不能早于当前时间。',
    thoiGianGiaoDichLocked: '系统设置不允许更改交易时间。',
    thoiGianGiaoDichOutOfRange: '交易时间超出允许的日期范围。',
    invalidDienThoaiNguoiNhan: '收货人电话号码无效（8–15位数字）。',
    invalidTrongLuong: '重量必须为非负数。',
    invalidKichThuoc: '尺寸（长/宽/高）必须为非负数。',
    warnStockCost: '库存/成本预警：{detail}',
    noData: '暂无数据。',
    noLines: '暂无明细行。',
    listSummary: '共 {count} 条',
    confirmDelete: '删除发票 {name}？',
    favoriteSuccess: '已更新收藏。',
    saoChepSuccess: '已复制发票。',
    statusSuccess: '已更新发票状态。',
    confirmKetThuc: '结束发票 {name}？状态将更新为已完成。',
    confirmHuy: '取消发票 {name}？状态将更新为已取消。',
    confirmHuySelected:
      '取消已选的 {count} 张发票？状态将更新为已取消。已取消 / 已完成 / 已锁定的发票将被跳过。',
    confirmHuyDaThu:
      '发票 {name} 客户已付 {soTien}。取消发票不会自动退款，该金额也不再计入应收款——请退款给客户或手动记录。仍要取消吗？',
    huySelectedSuccess: '已取消 {ok}/{total} 张发票。',
    huySelectedPartial: '已取消 {ok}/{total} 张发票。{fail} 张失败或无法取消。',
    huySelectedNone: '所选发票中没有可取消的单据。',
    paySuccess: '已记录付款。',
    invalidPayAmount: '付款金额无效。',
    importSuccess: '导入成功。',
    importDescription:
      '下载模板（无需发票号/渠道）。时间为空=当前，销售员=您。同一客户连续行合并；被隔开则拆单。',
    importWillCreate: '将根据所选文件创建 {count} 张发票。',
    importPreviewProgress: '预览 {current}/{total}',
    importPreviewStopped: '已停止预览。',
    importPreviewDone: '预览完成 {done}/{total} 张发票。',
    importPreviewLoading: '正在准备发票 {current}/{total}…',
    phieuXuatKhoFromInvoice: '按发票 {code} 销售出库',
    traHangNeedPhieuXuatKho: '请先创建出库单后再退货。',
    traHangDaTraHet: '已全部退货 — 无法再退。',
  },
  aria: {
    columnPicker: '选择显示列',
    toggleStar: '标记收藏',
    selectAllPage: '选择本页全部行',
    selectRow: '选择行',
  },
  detailTabs: {
    chung: '常规',
    generalInfo: '信息',
    chiTietDonHang: '订单明细',
    khoFlow: '仓库流程',
  },
  khoFlow: {
    trangThai: '履约状态',
    chuaToi: '尚未到达此步骤',
    empty: '该发票尚未进入仓库流程。',
  },
  actions: {
    pay: '付款',
    favorite: '收藏',
    changeStatus: '更改状态',
    print: '打印',
    printHoaDon: '打印发票',
    exportExcelHoaDon: '导出 Excel',
    printNhiet: '打印送货单',
    traHang: '退货',
    taoPhieuXuatKho: '创建出库单',
    phieuXuatKho: '出库单',
    saoChep: '复制',
    taoYeuCau: '创建VAT开票申请',
    taoYeuCauSelected: '创建开票申请（{count}）',
    taoYeuCauMenu: '创建开票申请',
    printSelected: '打印（{count}）',
    printMenu: '打印',
    huySelected: '取消（{count}）',
    huyMenu: '取消',
    bulkSelected: '操作（{count}）',
    ketThuc: '结束',
    taoDatHang: '创建订单',
    capNhat: '更新',
    dongY: '同意',
    xuLyDonHang: '处理订单',
    huyBo: '取消',
    exportFile: '导出文件',
    dieuChinhCot: '调整列',
    copy: '复制',
  },
  placeholders: {
    formTitle: '创建/编辑发票',
    formBody: '完整表单将后续补充。',
    ghiChu: '备注...',
    ghiChuGiao: '配送备注...',
    chonDoiTac: '选择合作方...',
  },
  pos: {
    tabNew: '新发票',
    newTabHoaDon: '新发票',
    newTabTraHang: '新退货',
    tabEdit: '编辑 {code}',
    tabClone: '复制 {code}',
    tabTitle: '发票 {n}',
    switchToDatHang: '转为订货',
    switchToHoaDon: '转为发票',
    tabFromDatHang: '新发票·来自 {code}',
    tabFromYeuCauSuaChua: '新发票·来自 {code}',
    addTab: '添加发票',
    history: '发票历史',
    confirmCloseTitle: '关闭此标签页？',
    confirmCloseBody: '该标签页有未保存的更改，关闭后将丢失。',
    openEdit: '打开编辑标签',
    openClone: '复制',
    saved: '发票已保存。',
  },
  summary: {
    tongTienHangCount: '商品总额（{count}）',
    tongSoLuong: '总数量',
    tongTienHang: '商品总额',
    giamGiaPhieuDat: '折扣',
    tongCong: '合计',
    hangSuaChua: '维修商品',
    maHangDeLai: '留置商品编码',
    capSuaChua: '组 {stt}',
  },
}
